import { Box, Modal as ModalMUI } from "@mui/material"
import { ModalProps } from "./props"
import { BoxContainer, ModalContainer, ModalWidthContainer } from "./styled"

const ModalBox = ({
  open,
  onClose,
  ariaLabel,
  ariaDescrib,
  children,
}: ModalProps) => (
  <ModalMUI
    sx={ModalContainer}
    open={open}
    onClose={onClose}
    aria-labelledby={ariaLabel}
    aria-describedby={ariaDescrib}
  >
    <Box sx={ModalWidthContainer}>
      <Box sx={BoxContainer}>{children}</Box>
    </Box>
  </ModalMUI>
)

export default ModalBox
